import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function StudentVoiceHouse({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const sv = data.student_voice || {};
  const hs = data.house_system || {};
  const HI = getIcon(hs.icon);
  const updateSv = (patch) => update({ student_voice: { ...sv, ...patch } });
  const updateHs = (patch) => update({ house_system: { ...hs, ...patch } });
  const svItems = sv.items || [];
  const updateSvItem = (i, patch) => {
    const next = svItems.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    updateSv({ items: next });
  };
  const hsParas = hs.paragraphs || [];
  const updateHsPara = (i, t) => {
    const next = [...hsParas];
    next[i] = t;
    updateHs({ paragraphs: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="card-surface p-8 h-full">
            <EditableText value={sv.heading} onChange={(t) => updateSv({ heading: t })} as="h3" className="font-display text-2xl" />
            <div className="mt-6 space-y-4">
              {svItems.map((t, i) => (
                <blockquote key={i} className="p-5 rounded-2xl bg-olive-light/50 border-l-4 border-accent">
                  <p className="text-ink/80 italic leading-relaxed">"<EditableText value={t.quote} onChange={(v) => updateSvItem(i, { quote: v })} as="span" multiline />"</p>
                  <footer className="mt-3 text-xs uppercase tracking-wider text-olive-deep font-semibold">— <EditableText value={t.name} onChange={(v) => updateSvItem(i, { name: v })} as="span" /> • <EditableText value={t.grade} onChange={(v) => updateSvItem(i, { grade: v })} as="span" /></footer>
                </blockquote>
              ))}
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-8 h-full bg-gradient-to-br from-olive-deep to-olive-footer text-white relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-accent/20 blur-3xl" />
            <HI className="text-accent" size={32} />
            <EditableText value={hs.heading} onChange={(t) => updateHs({ heading: t })} as="h3" className="font-display text-2xl mt-4" />
            {hsParas.map((p, i) => (
              <EditableText
                key={i}
                value={p}
                onChange={(t) => updateHsPara(i, t)}
                as="p"
                multiline
                className={`${i === 0 ? 'mt-4' : 'mt-3'} ${i === 0 ? 'text-white/80' : 'text-white/70'} leading-relaxed`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default StudentVoiceHouse;
